import intl from 'react-intl-universal';
import HistoryTable from 'components/HistoryTable';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import BatchEditModal from 'components/BatchEditModal';
import PropTypes from 'prop-types';
import { useMaterialUIController } from 'context';
import logger from 'utils/logger';
const propTypes = {
  columns: PropTypes.array.isRequired,
  tableData: PropTypes.array.isRequired,
  tableTitle: PropTypes.string.isRequired,
  handleOpenIssueDetails: PropTypes.func.isRequired,
  updateLocalProjectIssues: PropTypes.func.isRequired,
  reloadData: PropTypes.func.isRequired,
  setTimeRangeEnd: PropTypes.func.isRequired,
  setTimeRangeStart: PropTypes.func.isRequired,
  timeRangeStart: PropTypes.object.isRequired,
  timeRangeEnd: PropTypes.object.isRequired,
  issues: PropTypes.array.isRequired,
  doctors: PropTypes.array.isRequired,
  isSender: PropTypes.bool.isRequired,
  enableRowSelection: PropTypes.bool,
  onRowModelChange: PropTypes.func,
};

const log = logger.createLogger('History');

const History = ({
  columns,
  tableTitle,
  tableData,
  handleOpenIssueDetails,
  updateLocalProjectIssues,
  reloadData,
  setTimeRangeEnd,
  setTimeRangeStart,
  timeRangeStart,
  timeRangeEnd,
  issues,
  doctors,
  isSender,
  enableRowSelection = true,
  onRowModelChange,
}) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { enqueueSnackbar } = useSnackbar();
  const [batchEditModalIsOpen, setBatchEditModalIsOpen] = useState(false);
  const [selectedIssueIndexes, setSelectedIssueIndexes] = useState([]);

  const closeBatchEditModal = () => {
    setBatchEditModalIsOpen(false);
  };

  const handleRefreshClick = async () => {
    // Updating search times as the table will contain the same issues if time is not updated
    if (timeRangeEnd.toDateString() === new Date().toDateString()) {
      setTimeRangeEnd(new Date());
    }
    try {
      await reloadData();
      enqueueSnackbar(intl.get('shared_table_data_reload_success'), {
        variant: 'success',
        autoHideDuration: 3000,
      });
    } catch (error) {
      log.error('handleRefreshClick', error);
      enqueueSnackbar(intl.get('shared_table_data_reload_error'), {
        variant: 'error',
        autoHideDuration: 3000,
      });
    }
  };

  return (
    <>
      <div data-testid="page-width-control">
        <HistoryTable
          columns={columns}
          data={tableData}
          darkMode={darkMode}
          handleRefreshClick={handleRefreshClick}
          tableTitle={tableTitle}
          timeRangeStart={timeRangeStart}
          timeRangeEnd={timeRangeEnd}
          updateTimeRangeStart={setTimeRangeStart}
          updateTimeRangeEnd={setTimeRangeEnd}
          setBatchEditModalIsOpen={setBatchEditModalIsOpen}
          setSelectedIssueIndexes={setSelectedIssueIndexes}
          enableRowSelection={enableRowSelection}
          onRowModelChange={onRowModelChange}
        />

        {selectedIssueIndexes.length > 0 && batchEditModalIsOpen && (
          <BatchEditModal
            isSender={isSender}
            isOpened={batchEditModalIsOpen}
            closeModal={closeBatchEditModal}
            selectedIssueIndexes={selectedIssueIndexes}
            setSelectedIssueIndexes={setSelectedIssueIndexes}
            issues={issues}
            doctors={doctors}
            updateLocalProjectIssues={updateLocalProjectIssues}
            handleOpenIssueDetails={handleOpenIssueDetails}
          />
        )}
      </div>
    </>
  );
};

History.propTypes = propTypes;

export default History;
